import { UseQueryOptions } from 'react-query';
import { useGetAlertQuery } from '.';

export const useGetAlert = (id: string | undefined, options?: UseQueryOptions) => {
  const { data: item, ...result } = useGetAlertQuery(id, options);

  return {
    item,
    ...result,
  };
};
